export default __webpack_public_path__ + "static/media/octicon-markdown.d92633e9.svg";